// The task pane sections the EAV ribbon tab opens (Search, Account, Settings),
// and its notices (Insert Chart's reason for stopping, what Save as Values and
// Restore could not do). The ribbon commands
// (commands.ts, bundled into functions.js) and the pane (taskpane.ts, its own
// bundle) share the shared runtime's window but no module instance, so they
// meet through a window event.

export type PaneSection = "search" | "account" | "settings" | "notice";

export const PANE_SECTION_EVENT = "eav:pane-section";

/** How a notice reads: a failure (red) or plain information. */
export type NoticeKind = "error" | "info";

interface PaneRequest {
  section: PaneSection;
  text?: string;
  kind?: NoticeKind;
}

/** Ask the pane to show `section`, with `text` and `kind` for a notice (the pane must already be open: Office.addin.showAsTaskpane). */
export function requestPaneSection(section: PaneSection, text?: string, kind?: NoticeKind): void {
  globalThis.dispatchEvent(new CustomEvent<PaneRequest>(PANE_SECTION_EVENT, { detail: { section, text, kind } }));
}

/** Run `show` for every section the ribbon asks for. */
export function onPaneSection(show: (section: PaneSection, text?: string, kind?: NoticeKind) => void): void {
  globalThis.addEventListener(PANE_SECTION_EVENT, (e) => {
    const { section, text, kind } = (e as CustomEvent<PaneRequest>).detail;
    show(section, text, kind);
  });
}
